import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography } from '@mui/material';
import { IconUpload, IconX } from '@tabler/icons-react';

export default function ImagePicker({
  value,
  onChange,
  label,
  name = "name",
  disabled = false,
  uploadIconSize = 25,
  imagePreviewSize = 125,
}) {

  const inputId = `product-upload-${name}`;

  const [selectedImage, setSelectedImage] = useState(value || null);

  // Handle image selection
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const imageFile = {
      file,
      preview: URL.createObjectURL(file),
    };

    setSelectedImage(imageFile);
    if (onChange) onChange(imageFile);
    event.target.value = '';
  };

  // Handle image deletion
  const handleImageDelete = () => {
    if (selectedImage) {
      URL.revokeObjectURL(selectedImage.preview);
      setSelectedImage(null);
      if (onChange) onChange(null);
    }
  };

  return (
    <div>
      {label &&
        <Typography fontSize={"0.8rem"} color="#666666" paddingBottom={"10px"}>
          {label}
        </Typography>
      }
      {!selectedImage ? (
        <div
          onClick={() => !disabled && document.getElementById(inputId).click()}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: `${imagePreviewSize}px`,
            height: `${imagePreviewSize}px`,
            borderRadius: '5px',
            backgroundColor: '#FAFAFA',
            border: '1px dashed #D9D9D9',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          <IconUpload size={uploadIconSize} color="#999999" />
          <input
            type="file"
            accept="image/*"
            id={inputId}
            style={{ display: 'none' }}
            onChange={handleImageChange}
            disabled={disabled}
          />
        </div>
      ) : (
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: `${imagePreviewSize}px`,
            height: `${imagePreviewSize}px`,
            borderRadius: '5px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E5E5',
          }}
        >
          <img
            src={selectedImage.preview}
            alt="Preview"
            style={{
              width: `${imagePreviewSize - 5}px`,
              height: `${imagePreviewSize - 5}px`,
              borderRadius: '4px',
              objectFit: 'cover',
            }}
          />
          {!disabled && (
            <IconButton
              aria-label="delete"
              size="small"
              sx={{
                position: 'absolute',
                top: 6,
                right: 6,
                backgroundColor: '#D13F58',
                '&:hover': {
                  backgroundColor: '#D13F58',
                },
              }}
              onClick={handleImageDelete}
            >
              <IconX size={12} stroke={4} color="#FFFFFF" />
            </IconButton>
          )}
        </div>
      )}
    </div>
  );
}

ImagePicker.propTypes = {
  value: PropTypes.object, // Initial image { file, preview }
  onChange: PropTypes.func, // Callback for image selection
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool, // Disable interaction
  uploadIconSize: PropTypes.number, // Size of the upload icon
  imagePreviewSize: PropTypes.number, // Size of the image preview container
  onDelete: PropTypes.func, // Callback for image deletion
};

ImagePicker.defaultProps = {
  disabled: false,
  uploadIconSize: 25,
  imagePreviewSize: 125,
};
